import React, {useState} from 'react';
import {Pressable, StyleSheet, View} from 'react-native';
import {observer} from 'mobx-react-lite';

import theme from '../style/theme';

import Text from './ui-controls/Text';
import RangeFilterOptions from './RangeFilterOptions';
import RangeSortOptions from './RangeSortOptions';

const SORT = 'SORT';
const FILTER = 'FILTER';

const RangeSortFilterPanel = observer(() => {
  const [showPanel, setShowPanel] = useState(SORT);

  return (
    <View style={styles.container}>
      <View style={styles.buttonRow}>
        <Pressable
          style={[
            styles.button,
            showPanel === SORT ? styles.buttonSelected : null,
          ]}
          onPress={() => {
            setShowPanel(SORT);
          }}>
          <Text
            style={[
              styles.buttonText,
              showPanel === SORT ? styles.buttonTextSelected : null,
            ]}>
            SORT
          </Text>
        </Pressable>
        <Pressable
          style={[
            styles.button,
            showPanel === FILTER ? styles.buttonSelected : null,
          ]}
          onPress={() => {
            setShowPanel(FILTER);
          }}>
          <Text
            style={[
              styles.buttonText,
              showPanel === FILTER ? styles.buttonTextSelected : null,
            ]}>
            FILTER
          </Text>
        </Pressable>
      </View>
      <View style={{flex: 1, overflow: 'hidden'}}>
        {showPanel === SORT && <RangeSortOptions />}
        {showPanel === FILTER && <RangeFilterOptions />}
      </View>
    </View>
  );
});

export default RangeSortFilterPanel;

const styles = StyleSheet.create({
  container: {
    width: '100%',
    padding: 8,
    paddingBottom: 4,
    backgroundColor: 'white',
    flex: 1,
  },
  buttonRow: {
    flexDirection: 'row',
    alignSelf: 'stretch',
  },
  button: {
    borderWidth: 1,
    borderColor: theme.colour.border.general.primary,
    borderRadius: 4,
    backgroundColor: 'white',
    flex: 1,
    paddingVertical: 4,
    alignItems: 'center',
    marginHorizontal: 4,
  },
  buttonSelected: {
    backgroundColor: theme.colour.border.general.primary,
  },
  buttonText: {
    color: theme.colour.general.primary,
  },
  buttonTextSelected: {
    color: 'white',
  },
});
